export enum RoleColors {
  talker = '#8B5EB0',
  sherpa = '#ff8b05',
  admin = '#8B5EB0',
}